import { render, staticRenderFns } from "./roster.vue?vue&type=template&id=1a816f7c"
import script from "./roster.vue?vue&type=script&lang=js"
export * from "./roster.vue?vue&type=script&lang=js"
import style0 from "./roster.vue?vue&type=style&index=0&id=1a816f7c&prod&lang=css"
import style1 from "./roster.vue?vue&type=style&index=1&id=1a816f7c&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports